import MeterInput from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInput/MeterInput'
import MeterConsent from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterConsent'
import MeterInformation from '@/containers/SubscriptionFormPageNew/Components/GasMeter/Fields/MeterInformation'
import useGasMeterListener from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeterListener'
import useGasMeterSave from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeterSave'
import PceSearchModal from '@/containers/SubscriptionFormPageNew/Components/GasMeter/PceSearch/PceSearchModal'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const GasMeter = () => {
  useGasMeterListener()
  const { saveGasMeter, isSaving, canSave, t } = useGasMeterSave()

  return (
    <>
      <MeterInput />
      <MeterConsent />
      <MeterInformation type='client' />
      <div>
        <SDButton style={{ width: '100%' }} disabled={!canSave} isLoading={isSaving} onClick={saveGasMeter}>
          {t('common:save')}
        </SDButton>
      </div>
      <PceSearchModal />
    </>
  )
}

export default GasMeter
